/* eslint-disable no-unused-vars */
const ROTA_GITGUB = "/pibcr/";
const ROTA_LOCAL = "/";

export const ROTA = ROTA_LOCAL;
